import { Link } from 'react-router-dom';

export default function FeaturesPage() {
  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-200">
        <nav className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <h1>
              <Link to="/" className="flex items-center gap-3 hover:opacity-70 transition-opacity cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/ee77cd5e24359f194577e6ccca300426.png" 
                  alt="Nowest ロゴ" 
                  className="h-10 w-auto object-contain"
                />
                <span className="text-2xl font-semibold text-primary">Nowest</span>
              </Link>
            </h1>
            <div className="hidden md:flex items-center space-x-10">
              <Link to="/" className="text-secondary hover:text-primary transition-colors font-medium cursor-pointer">
                トップ
              </Link>
              <Link to="/features" className="text-primary font-medium cursor-pointer">
                特徴
              </Link>
              <Link to="/about" className="text-secondary hover:text-primary transition-colors font-medium cursor-pointer">
                会社概要
              </Link>
              <button onClick={scrollToContact} className="bg-primary text-white px-6 py-2.5 hover:bg-accent transition-colors font-medium whitespace-nowrap cursor-pointer">
                お問い合わせ
              </button>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero */}
      <section className="pt-32 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center gap-2 text-sm text-secondary mb-8">
            <Link to="/" className="hover:text-primary transition-colors cursor-pointer">Top</Link>
            <span>/</span>
            <span className="text-primary">特徴</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6">Nowestの特徴</h2>
          <p className="text-xl text-secondary max-w-3xl">
            独自メソッドとAIテクノロジーで、すべての人に学びの成功を
          </p>
        </div>
      </section>

      {/* Main Features */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 mb-24">
            <div className="flex flex-col justify-center">
              <div className="inline-block bg-primary text-white px-4 py-2 text-sm font-medium mb-6 self-start">
                FEATURE 01
              </div>
              <h3 className="text-3xl font-bold text-primary mb-6">
                ギネス世界記録保持者が開発<br />独自の記憶メソッド
              </h3>
              <p className="text-lg text-secondary mb-6 leading-relaxed">
                ギネス・ワールド・レコーズの記憶競技（オセロボード暗記）の世界記録保持者としての実績を基に開発した独自の記憶メソッドは、体系化されており再現性が非常に高いのが特徴です。
              </p>
              <p className="text-lg text-secondary leading-relaxed">
                誰でも実践できるよう設計されたこのメソッドにより、様々な内容を効果的に覚えることができます。記憶が苦手だった方でも、正しい方法を学ぶことで確実に記憶力を向上させることができます。
              </p>
            </div>
            <div>
              <img
                src="https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/790e646ad541cfc536720f82f9fc4471.jpeg"
                alt="独自の記憶メソッド"
                className="w-full object-cover object-top shadow-lg"
              />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 mb-24">
            <div className="lg:order-2 flex flex-col justify-center">
              <div className="inline-block bg-primary text-white px-4 py-2 text-sm font-medium mb-6 self-start">
                FEATURE 02
              </div>
              <h3 className="text-3xl font-bold text-primary mb-6">
                AIチューター&ゲームによる<br />パーソナライズドサポート
              </h3>
              <p className="text-lg text-secondary mb-6 leading-relaxed">
                独自の記憶メソッドを学習させたAIチューターが、一人ひとりの学習をサポート。さらにAIを活用したゲームで楽しく学習を継続できます。イメージがしにくい方、記憶が苦手な方でも、AIが最適な学習方法を提案します。
              </p>
              <p className="text-lg text-secondary leading-relaxed">
                読み書きに障害がある方、ADHD・ASDなどの発達特性をお持ちのお子さんも対象です。AIチューターのサポートとゲーム要素により、発達障害・学習障害のあるお子さまが「覚える」技能を習得し、自律的な学習へとつながった療育実績も多数あります。
              </p>
            </div>
            <div className="lg:order-1">
              <img
                src="https://public.readdy.ai/ai/img_res/ae996c62d78c075c216ed187514ab4e4.jpg"
                alt="AIチューター&ゲームサポート"
                className="w-full object-cover object-top shadow-lg"
              />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 mb-24">
            <div className="flex flex-col justify-center">
              <div className="inline-block bg-primary text-white px-4 py-2 text-sm font-medium mb-6 self-start">
                FEATURE 03
              </div>
              <h3 className="text-3xl font-bold text-primary mb-6">
                自己肯定感を育む<br />成功体験の積み重ね
              </h3>
              <p className="text-lg text-secondary mb-6 leading-relaxed">
                私たちが最も大切にしているのは、「覚えられた」という小さな成功体験の積み重ねです。この成功体験により、自己効力感や自己肯定感が高まります。
              </p>
              <p className="text-lg text-secondary leading-relaxed">
                記憶力の向上だけでなく、より自分らしく生き生きとした人生を送ることができる。そんな長期的なベネフィットを目指しています。学習を通じて得られる自信は、人生のあらゆる場面で力になります。
              </p>
            </div>
            <div>
              <img
                src="https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/95c4cbe7f8f6db71aeaeae85259aecc6.jpeg"
                alt="自己肯定感の育成"
                className="w-full object-cover object-top shadow-lg"
              />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-16">
            <div className="lg:order-2 flex flex-col justify-center">
              <div className="inline-block bg-primary text-white px-4 py-2 text-sm font-medium mb-6 self-start">
                FEATURE 04
              </div>
              <h3 className="text-3xl font-bold text-primary mb-6">
                イメージ力で広がる<br />可能性
              </h3>
              <p className="text-lg text-secondary mb-6 leading-relaxed">
                記憶メソッドの習得を通じて、イメージ力を鍛えることができます。このイメージ力は、記憶だけでなく、目標達成や感情のセルフコントロールにも役立ちます。
              </p>
              <p className="text-lg text-secondary leading-relaxed">
                目標を明確にイメージする力、困難な状況でも冷静に対処する力。これらの能力は、学習だけでなく、人生のあらゆる場面で活かすことができます。
              </p>
            </div>
            <div className="lg:order-1">
              <img
                src="https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/c6274f1bc781ae98593eaea69731100a.jpeg"
                alt="イメージ力の育成"
                className="w-full object-cover object-top shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Grid */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl font-bold text-primary mb-4">こんな方におすすめ</h3>
            <p className="text-lg text-secondary">
              Nowestのメソッドは、様々な学習ニーズに対応しています
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 mb-4">
                <i className="ri-user-heart-line text-2xl text-primary"></i>
              </div>
              <h4 className="text-xl font-bold text-primary mb-3">記憶が苦手な方</h4>
              <p className="text-secondary">
                体系化されたメソッドで、誰でも再現性高く記憶力を向上させることができます
              </p>
            </div>

            <div className="bg-white p-8 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 mb-4">
                <i className="ri-parent-line text-2xl text-primary"></i>
              </div>
              <h4 className="text-xl font-bold text-primary mb-3">お子さんの学習をサポートしたい親御さん</h4>
              <p className="text-secondary">
                AIチューターと共に、お子さんの学習を効果的にサポートできます
              </p>
            </div>

            <div className="bg-white p-8 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 mb-4">
                <i className="ri-heart-pulse-line text-2xl text-primary"></i>
              </div>
              <h4 className="text-xl font-bold text-primary mb-3">発達特性・発達障害のあるお子さん</h4>
              <p className="text-secondary">
                ADHD・ASD・学習障害など発達特性のあるお子さんも対象。「覚える」技能を支援し、自律的な学習へつなげた療育実績多数
              </p>
            </div>

            <div className="bg-white p-8 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 mb-4">
                <i className="ri-book-read-line text-2xl text-primary"></i>
              </div>
              <h4 className="text-xl font-bold text-primary mb-3">読み書きに困難がある方</h4>
              <p className="text-secondary">
                視覚的なイメージを活用した学習で、読み書きの障害をサポート
              </p>
            </div>

            <div className="bg-white p-8 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 mb-4">
                <i className="ri-trophy-line text-2xl text-primary"></i>
              </div>
              <h4 className="text-xl font-bold text-primary mb-3">資格取得を目指す方</h4>
              <p className="text-secondary">
                効率的な記憶メソッドで、資格試験の学習を強力にサポート
              </p>
            </div>

            <div className="bg-white p-8 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 mb-4">
                <i className="ri-team-line text-2xl text-primary"></i>
              </div>
              <h4 className="text-xl font-bold text-primary mb-3">企業の人材育成担当者</h4>
              <p className="text-secondary">
                社員の学習効率を高め、業務パフォーマンスを向上させます
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h3 className="text-3xl font-bold text-primary mb-6">
            まずはお気軽にご相談ください
          </h3>
          <p className="text-lg text-secondary mb-10">
            あなたやお子さんに最適な学習方法をご提案いたします
          </p>
          <button
            onClick={scrollToContact}
            className="inline-block bg-primary text-white px-10 py-4 hover:bg-accent transition-colors font-semibold whitespace-nowrap cursor-pointer"
          >
            お問い合わせはこちら
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-primary text-gray-300">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            <div className="md:col-span-2">
              <h4 className="text-2xl font-semibold text-white mb-4">Nowest</h4>
              <p className="text-gray-400 mb-6 leading-relaxed">
                「覚えられない」を無くす。ギネス世界記録保持者が開発した独自の記憶メソッドとAIで、すべての人に学びの成功体験を提供します。
              </p>
            </div>
            <div>
              <h5 className="text-white font-semibold mb-4">サービス</h5>
              <ul className="space-y-3">
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">オンラインスクール</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">法人向け研修</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">コンテンツ制作</Link></li>
              </ul>
            </div>
            <div>
              <h5 className="text-white font-semibold mb-4">会社情報</h5>
              <ul className="space-y-3">
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">会社概要</Link></li>
                <li><Link to="/features" className="hover:text-white transition-colors cursor-pointer">特徴</Link></li>
                <li><Link to="/legal" className="hover:text-white transition-colors cursor-pointer">特定商取引法</Link></li>
                <li><button onClick={scrollToContact} className="hover:text-white transition-colors cursor-pointer text-left">お問い合わせ</button></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">© 2025 Nowest,inc. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
